import React from 'react';

import { AppContextProps } from 'app/context/app-context-props';
import { AppConfigName } from 'app/enum/app-config-name';

/**
 * The empty Context should define reasonable value for each AppConfigName, so that if app tries to access it before
 * it getting loaded from server, we don't get undefined exceptions and complete crash.
 */
export const emptyContext: AppContextProps = {
    appConfigs: {
        [AppConfigName.ILLEGAL_CHARS]: {
            id: '',
            name: AppConfigName.ILLEGAL_CHARS,
            value: [],
        },
        [AppConfigName.CHANNEL_METHOD]: {
            id: '',
            name: AppConfigName.CHANNEL_METHOD,
            value: [],
        },
        [AppConfigName.MATCH_METHOD]: {
            id: '',
            name: AppConfigName.MATCH_METHOD,
            value: [],
        },
    },
};

export const AppContext = React.createContext<AppContextProps>(emptyContext);
